import { apiGet } from "@/lib/api-error";
import type { SessionMembersResponse } from "@/types";

/**
 * Upit za dijalog "Članovi". Uvijek svjež (bez globalnog staleTime-a od 60 s):
 * PUT šalje cijeli spisak, pa bi zastarjeli spisak obrisao člana dodanog
 * maloprije i skinuo ga sa Meeta.
 */
export function sessionMembersQuery(sessionId: string) {
  return {
    queryKey: ["session-members", sessionId] as const,
    queryFn: () => apiGet<SessionMembersResponse>(`/api/sessions/${sessionId}/members`, "Greška pri učitavanju članova"),
    staleTime: 0,
    gcTime: 0,
  };
}
